// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cwywjvyljtduvwocrjmy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3eXdqdnlsanRkdXZ3b2Nyam15Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2OTk3MTksImV4cCI6MjA2OTI3NTcxOX0.aNcNZNyYKpXkJmpgFTBxWWKpjg-rw8ivqJTzB-nI0pA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});